import React, { ReactNode } from 'react';
import { Grid, Typography, TypographyProps } from '@material-ui/core';
import styles from './Header.module.scss';

interface HeaderProps {
  title: ReactNode;
  directions?: ReactNode;
  hideDirections?: boolean;
}

const Header = ({ title, directions, hideDirections = false }: HeaderProps): JSX.Element => {
  const propsOverride: { variant?: string } = {};
  return (
    <Grid container alignItems='center' direction='column' component='div'>
      <Typography variant='h1' className={styles.item}>
        {title}
      </Typography>
      {!hideDirections && directions && (
        <Typography {...(propsOverride as TypographyProps)} className={styles.item}>
          {directions}
        </Typography>
      )}
    </Grid>
  );
};

export default Header;
